import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { LAYOUT } from "@/constants/testIds";
import { ALL_NAV_ITEMS } from "@/constants/nav";
import {
  CommandDialog, CommandEmpty, CommandGroup, CommandInput,
  CommandItem, CommandList, CommandSeparator,
} from "@/components/ui/command";

export default function CommandPalette({ open, onOpenChange }) {
  const nav = useNavigate();

  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        onOpenChange(!open);
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [open, onOpenChange]);

  const go = (path) => {
    onOpenChange(false);
    nav(path);
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange} data-testid={LAYOUT.cmdkPalette}>
      <CommandInput placeholder="Search pages, actions, or shortcuts…" />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup heading="Navigate">
          {ALL_NAV_ITEMS.map((it) => {
            const IconCmp = Icons[it.icon] || Icons.Circle;
            return (
              <CommandItem key={it.key} onSelect={() => go(it.to)}>
                <IconCmp className="w-4 h-4 mr-2 text-white/60" />
                {it.label}
              </CommandItem>
            );
          })}
        </CommandGroup>
        <CommandSeparator />
        <CommandGroup heading="Quick actions">
          <CommandItem onSelect={() => go("/services")}>
            <Icons.PlusCircle className="w-4 h-4 mr-2" /> Add new service
          </CommandItem>
          <CommandItem onSelect={() => go("/blog")}>
            <Icons.PenSquare className="w-4 h-4 mr-2" /> Create blog post
          </CommandItem>
          <CommandItem onSelect={() => go("/media")}>
            <Icons.Upload className="w-4 h-4 mr-2" /> Upload media
          </CommandItem>
          <CommandItem onSelect={() => go("/leads")}>
            <Icons.Inbox className="w-4 h-4 mr-2" /> View leads
          </CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
